/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import LogModel from 'cio/models/log';
import { ActivityLogType } from 'cio/utils/activity-log-types';

interface ActivityLogRowObjectArgs {
  log: LogModel;
}

export default class ActivityLogRowObject extends Component<ActivityLogRowObjectArgs> {
  get isObjectDeleteType() {
    return this.args.log.parsedType === ActivityLogType.ObjectDelete;
  }
}
